<template xmlns:background-color="http://www.w3.org/1999/xhtml">
  <a-row :gutter="10">
    <a-col :md="10" :sm="24">
      <a-card :bordered="false">

        <!-- 按钮操作区域 -->
        <a-row style="margin-left: 14px">
          <a-button :disabled="importPlatformbtn" @click="selectStandardDepart" type="primary">{{language['system.showPlatformDeport']}}</a-button>
          <a-button @click="handleAdd(1)" type="primary" disabled='true'>{{language['depart.management.addDepart']}}</a-button>
          <a-button @click="handleAdd(2)" type="primary" disabled='true'>{{language['depart.management.addNext']}}</a-button>
          <!--<a-button type="primary" icon="download" @click="handleExportXls('部门信息')">导出</a-button>
          <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
            <a-button type="primary" icon="import">导入</a-button>
          </a-upload>-->
          <a-button :title="language['system.removeMoreitem']" @click="batchDel" type="default" disabled='true'>{{language['common.batchDelete']}}</a-button>
          <!--<a-button @click="refresh" type="default" icon="reload" :loading="loading">刷新</a-button>-->
          <!--<a-button type="primary" icon="download" @click="ExportTemplateXls">导出模板</a-button>-->
          <a-button v-has="'platform_departlist:import'" type="primary" icon="download" @click="uploadDepartXls" disabled='true'>{{language['common.importButton']}}</a-button><!--'departlist:import'-->
        </a-row>
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{language['depart.management.selectedDepart']}}：<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="onClearSelected">{{language['depart.management.cancelSelected']}}</a>
            </div>
          </a-alert>
          <a-input-search @search="onSearch" style="width:100%;margin-top: 10px" :placeholder="language['common.pleaseInput']+language['depart.management.departName']"/>

          <!-- 树-->
          <a-col :md="10" :sm="24" style="max-height: 100vh;overflow-y:scroll;overflow-x: hidden;width: 100%">
            <template>
              <a-dropdown :trigger="[this.dropTrigger]" @visibleChange="dropStatus" style="height: 100px">
                <span style="user-select: none">
                  <a-tree
                    :show-line="true"
                    :show-icon="false"
                    @select="onSelect"
                    @check="onCheck"
                    @rightClick="rightHandle"
                    :selectedKeys="selectedKeys"
                    :checkedKeys="checkedKeys"
                    :treeData="departTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand"/>
                </span>
                <!--新增右键点击事件,和增加添加和删除功能-->
                <a-menu slot="overlay">
                  <a-menu-item @click="handleAdd(3)" key="1">{{language['button.add']}}</a-menu-item>
                  <a-menu-item @click="handleDelete" key="2">{{language['common.delete']}}</a-menu-item>
                  <a-menu-item @click="closeDrop" key="3">{{language['common.cancel']}}</a-menu-item>
                  <a-menu-item @click="handleTransferOrg(departTree,selectedKeys)" key="4" v-has="'platform_departlist:transferDeport'">{{language['depart.management.transferDeport']}}</a-menu-item>
                  <a-menu-item @click="handleTransferPerson(departTree,selectedKeys)" key="5" v-has="'platform_departlist:transferDeportUser'">{{language['depart.management.transferDeportUser']}}</a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </a-col>
        </div>
      </a-card>
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      <div class="drawer-bootom-button">
        <a-dropdown :trigger="['click']" placement="topCenter">
          <a-menu slot="overlay">
            <!--<a-menu-item key="1" @click="switchCheckStrictly(1)">父子关联</a-menu-item>
            <a-menu-item key="2" @click="switchCheckStrictly(2)">取消关联</a-menu-item>-->
            <a-menu-item key="3" @click="checkALL">{{language['system.allcheck']}}</a-menu-item>
            <a-menu-item key="4" @click="cancelCheckALL">{{language['system.cancelcheckall']}}</a-menu-item>
            <a-menu-item key="5" @click="expandAll">{{language['system.expenseall']}}</a-menu-item>
            <a-menu-item key="6" @click="closeAll">{{language['system.collegeall']}}</a-menu-item>
          </a-menu>
          <a-button>
            {{language['system.treeoperate']}} <a-icon type="up" />
          </a-button>
        </a-dropdown>
      </div>
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
    </a-col>
    <a-col :md="14" :sm="24">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane :tab="language['depart.management.basicInfo']" key="1" >
          <a-card :bordered="false" v-if="selectedKeys.length>0">
            <a-form-model ref="form" :model="model" :rules="validatorRules">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="departName" :label="language['depart.management.departName']">
                <a-input :placeholder="language['common.pleaseInput']+language['depart.management.departName']" v-model="model.departName" style="width: 85%"/>
                <a-button @click="departNameLanguageOpen" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
              </a-form-model-item>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="language['depart.management.FDepart']">
                <a-tree-select
                  style="width:100%"
                  :dropdownStyle="{maxHeight:'200px',overflow:'auto'}"
                  :treeData="treeData"
                  :disabled="disable"
                  v-model="model.parentId"
                  :placeholder="language['common.not']">
                </a-tree-select>
              </a-form-model-item>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="orgCode" :label="language['depart.management.orgCode']">
                <a-input disabled :placeholder="language['common.pleaseInput']+language['depart.management.orgCode']" v-model="model.orgCode" />
              </a-form-model-item>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol"  :label="language['depart.management.thirdOrgCode']">
                <a-input   v-model="model.thirdOrgCode" :maxLength="100"/>
              </a-form-model-item>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="orgCategory" :label="language['depart.management.orgCategory']">
                <template v-if="orgCategoryDisabled">
                  <a-radio-group v-model="model.orgCategory" :placeholder="language['common.pleaseInput']+language['depart.management.orgCategory']">
                    <a-radio value="1">
                      {{language['common.company']}}
                    </a-radio>
                  </a-radio-group>
                </template>
                <template v-else>
                  <a-radio-group v-model="model.orgCategory" :placeholder="language['common.pleaseInput']+language['depart.management.orgCategory']">
                    <a-radio value="2">
                      {{language['depart']}}
                    </a-radio>
                    <a-radio value="3">
                      {{language['common.post']}}
                    </a-radio>
                  </a-radio-group>
                </template>
              </a-form-model-item>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="language['common.sort']">
                <a-input-number v-model="model.departOrder" />
              </a-form-model-item>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="language['depart.management.mobile']">
                <a-input :placeholder="language['common.pleaseInput']+language['depart.management.mobile']" v-model="model.mobile" />
              </a-form-model-item>
              <a-form-model-item  :labelCol="labelCol" :wrapperCol="wrapperCol"  :label="language['depart.management.address']">
                <a-input :placeholder="language['common.pleaseInput']+language['depart.management.address']" v-model="model.address"/>
              </a-form-model-item>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="language['depart.management.memo']">
                <a-textarea :placeholder="language['common.pleaseInput']+language['depart.management.memo']" v-model="model.memo"/>
              </a-form-model-item>
              <a-form-model-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="language['depart.management.expenseCode']">
                <a-input :placeholder="language['common.pleaseInput']+language['depart.management.expenseCode']" v-model="model.expenseCode"/>
              </a-form-model-item>
              <a-form-model-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                prop="levelNo"
                :label="language['depart.management.levelNo']">

                <j-dict-select-tag v-model="model.levelNo" :placeholder="language['common.pleaseChoose']+language['depart.management.levelNo']" :allowClear="true" :dictCode="levelDictCode" v-if="!!levelDictCode"/>
              </a-form-model-item>
              <a-form-model-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :label="language['depart.management.deportDirector']">
                <j-select-user :placeholder="language['common.pleaseChoose']+language['depart.management.deportDirector']" :multiple="false" v-model="model.departChief" :url="departMangerURL" rowKey="workNo" />
              </a-form-model-item>

              <a-form-model-item
                prop="artificialPerson"
                :label="language['depart.management.artificialPerson']"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol">
                <a-select
                  style="width: 100%"
                  allowClear
                  :placeholder="language['common.pleaseChoose']+language['depart.management.artificialPerson']"
                  v-model="model.artificialPerson">
                  <a-select-option v-for="(item,index) in artificialPersonList" :key="index.toString()" :value="item.id">
                    {{ item.legalpersonName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item
                prop="siteCode"
                :label="language['depart.management.siteCode']"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol">
                <a-select
                  style="width: 100%"
                  allowClear
                  :placeholder="language['common.pleaseChoose']+language['depart.management.siteCode']"
                  v-model="model.siteCode">
                  <a-select-option v-for="(item,index) in siteCodeList" :key="index.toString()" :value="item.id">
                    {{ item.factoryName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-form-model>
            <div class="anty-form-btn">
              <a-button @click="emptyCurrForm" type="default" htmlType="button" icon="sync">{{language['common.resetButton']}}</a-button>
              <a-button @click="submitCurrForm" type="primary" htmlType="button" icon="form">{{language['common.save']}}</a-button>
            </div>
          </a-card>
          <a-card v-else >
            <a-empty>
              <span slot="description"> {{language['warning.departRequired']}}</span>
            </a-empty>
          </a-card>
        </a-tab-pane>
        <a-tab-pane :tab="language['depart.management.deportProemission']" key="2" forceRender>
          <depart-auth-modal ref="departAuth"/>
        </a-tab-pane>
        <a-tab-pane :tab="language['depart.management.deportUser']" key="3">
          <a-card style="padding-left: 25px;padding-right: 25px;" v-if="selectedKeys.length>0">
            <!--<Dept-User-Info ref="DeptUserInfo" @clearSelectedDepartKeys=""></Dept-User-Info>-->
            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="id"
              :pagination="ipagination"
              :columns="userColumns"
              :dataSource="userDataSource"
              :loading="userTabelLoading"
              @change="userTableChange">
            </a-table>
          </a-card>
          <a-card v-else>
            <a-empty>
              <span slot="description"> {{language['warning.departRequired']}} </span>
            </a-empty>
          </a-card>
        </a-tab-pane>
        <a-tab-pane :tab="this.language['depart.management.departUserPermission']" key="4" ><!--v-has="'platform_departlist:setDimensionCode'"-->
          <a-card style="padding-left: 25px;padding-right: 25px;" v-if="selectedKeys.length>0">
            <a-form>
              <a-row :gutter="24">
<!--                <a-col :md="8" :sm="8">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  :label="`工号`">
                    <a-input :placeholder="language['common.pleaseInput']+language['user.column.workNo']" v-model="dimensionCodeQueryParamWorkNo" allowClear></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="8">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  :label="`姓名`">
                    <a-input :placeholder="language['common.pleaseInput']+language['column.realName']" v-model="dimensionCodeQueryParamRealName" allowClear></a-input>
                  </a-form-item>
                </a-col>-->
                <a-col :md="16" :sm="16">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  :label="language['user.column.userName']">
                    <a-input :placeholder="language['common.pleaseInput']+language['user.column.userName']" v-model="dimensionCodeQueryParamUsername" allowClear></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="8">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  >
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="dimensionCodeSearch" icon="search">{{language['common.searchButton']}}</a-button>
                      <a-button type="primary" @click="dimensionCodeSearchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
                    </span>
                  </a-form-item>
                </a-col>
              </a-row>


              <a-row :gutter="24">
                <a-col :md="16" :sm="16">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  :label="this.language['depart.management.dimension']">
                    <a-select
                      style="width: 100%"
                      allowClear
                      mode="multiple"
                      show-search option-filter-prop="children"
                      v-model="submitDimensionCode">
                      <a-select-option v-for="(item,index) in dataPermissionList" :key="index" :value="item.dimensionCode">{{item.dimensionName}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="8">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  >
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="submitData" icon="search">{{ language['common.batchSetting'] }}</a-button>
                    </span>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>


            <a-table
              ref="table"
              size="middle"
              bordered
              rowKey="id"
              :pagination="ipagination2"
              :columns="userColumns2"
              :dataSource="userDataSource2"
              :loading="userTabelLoading2"
              :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
              @change="userTableChange2">
              <template slot="dimensionName" slot-scope="text, record, index">
                <a-select mode="multiple" :disabled="!record.editable" v-model="record.dimensionCode" :getPopupContainer= "(target) => target.parentNode" style="width: 80%">
                  <a-select-option v-for="(item,index) in dataPermissionList" :key="index" :value="item.dimensionCode">{{item.dimensionName}}</a-select-option>
                </a-select>
              </template>
              <template slot="action" slot-scope="text, record, index">
                <div class="editable-row-operations">
                <span v-if="record.editable">
                  <a @click="() => userData2save(record)">{{language['common.save']}}</a>
                  <a-divider type="vertical" />
                  <a-popconfirm :title="language['message.giveUpEditing']" @confirm="() => userData2cancel(record)">
                    <a>{{language['common.cancel']}}</a>
                  </a-popconfirm>
                </span>
                  <span v-else>
                  <a class="edit" @click="() => userData2edit(record.id)" >{{language['common.edit']}}</a>
                </span>
                </div>
              </template>
            </a-table>
          </a-card>
          <a-card v-else>
            <a-empty>
              <span slot="description"> {{language['warning.departRequired']}} </span>
            </a-empty>
          </a-card>
        </a-tab-pane>

        <a-tab-pane tab="签核人自定义" key="5"  forceRender>
          <a-card v-show="this.selectedKeys.length>0">
<!--            <epi-check-user-set ref="checker" :bgId="selectedKeys[0]" ></epi-check-user-set>-->
          </a-card>
          <a-card v-show="this.selectedKeys.length===0">
            <a-empty>
              <span slot="description" > {{language['warning.departRequired']}} </span>
            </a-empty>
          </a-card>
        </a-tab-pane>
      </a-tabs>

    </a-col>
    <depart-modal ref="departModal" @ok="loadTree" :factoryList="siteCodeList" :legalPersonList="artificialPersonList"></depart-modal>
    <depart-transfer-modal ref="departTransferModal" @ok="loadTree" :factoryList="siteCodeList" :legalPersionList="artificialPersonList"></depart-transfer-modal>
    <depart-transfer-employee-modal ref="departTransferEmployeeModal" @ok="loadTree"></depart-transfer-employee-modal>
    <standard-depart-modal ref="standardDepartModal" @ok="loadTree"></standard-depart-modal>
    <depart-upload-or-download-modal ref="DepartUploadOrDownloadModal" @ok="loadTree"></depart-upload-or-download-modal>
    <language-model ref="languageModel" @ok="languageOk"></language-model>
  </a-row>
</template>
<script>
  import DepartModal from './modules/DepartModal'
  import LanguageModel from "@/components/LanguageModel"
  // import DeptUserInfo from './modules/DeptUserInfo'
  import StandardDepartModal from './modules/StandardDepartModal'
  import {queryDepartTreeList, searchByKeywords, deleteByDepartId} from '@/api/api'
  import {httpAction, deleteAction, getAction} from '@/api/manage'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import DepartAuthModal from './modules/DepartAuthModal'
  import DepartTransferModal from "./modules/DepartTransferModal";
  import DepartTransferEmployeeModal from "./modules/DepartTransferEmployeeModal";
  // import EpiCheckUserSet from "../episys/check/EpiCheckUserSetList";
  import DepartUploadOrDownloadModal from "./modules/DepartUploadOrDownloadModal";
  import {postAction} from "../../api/manage";
  // 表头

  export default {
    name: 'DepartList',
    mixins: [JeecgListMixin],
    components: {
      DepartTransferModal,
      DepartTransferEmployeeModal,
      DepartAuthModal,
      DepartModal,
      StandardDepartModal,
      DepartUploadOrDownloadModal,
      LanguageModel,
      // EpiCheckUserSet
    },
    data() {
      return {
        appCode:this.$store.getters.applicationCode,
        importBtnHas:'',
        userDataSource:[],
        userTabelLoading:false,


        allTreeNodes:[],
        artificialPersonList:[{
          id:'',
          applicationName:''
        }],
        siteCodeList:[{
          id:'',
          xxx:''
        }],
        iExpandedKeys: [],
        loading: false,
        autoExpandParent: true,
        currFlowId: '',
        currFlowName: '',
        disable: true,
        treeData: [],
        visible: false,
        importPlatformbtn:true,
        departTree: [],
        // standardDepartShow:true,
        rightClickSelectedKey: '',
        rightClickSelectedOrgCode: '',
        hiding: true,
        model: {},
        dropTrigger: '',
        depart: {},
        disableSubmit: false,
        checkedKeys: [],
        selectedKeys: [],
        autoIncr: 1,
        currSelected: {},
        allTreeKeys:[],
        checkStrictly: true,
        labelCol: {
          xs: {span: 24},
          sm: {span: 5}
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16}
        },
        graphDatasource: {
          nodes: [],
          edges: []
        },
        validatorRules: {
          departName: [{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['depart.management.departName']}],
          orgCode: [{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['depart.management.orgCode']}],
          orgCategory:[{required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['depart.management.orgCategory']}],
          mobile:[{validator: this.validateMobile}],
          levelNo:[{ required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['depart.management.levelNo'] }],
        },
        url: {
          delete: '/sys/sysDepart/delete',
          edit: '/sys/sysDepart/edit',
          deleteBatch: '/sys/sysDepart/deleteBatch',
          exportXlsUrl: "sys/sysDepart/exportXls",
          importExcelUrl: "sys/sysDepart/importExcel",
        },
        orgCategoryDisabled:false,

        departMangerURL:'/sys/user/queryList?applicationCode='+this.$store.getters.applicationCode+'&applicationBy=user',

        ipagination2:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        dimensionCodeQueryParamWorkNo:'',
        dimensionCodeQueryParamRealName:'',
        dimensionCodeQueryParamUsername:'',
        userDataSource2:[],
        userTabelLoading2:false,
        dataPermissionList:[],
        submitDimensionCode:[],
        // departNameLanguages:[],
        // checkedDataId:'',

        levelDictCode:'',
        envchargeModel:[],
      }
    },
    created(){
      this.onClearSelected();
      this.currFlowId = this.$route.params.id
      this.currFlowName = this.$route.params.name
      // this.loadTree()
      this.getLegalPersons();
      this.getDepartSites();
      this.initDataPermissionList();

      this.getlevelDictCode();

      this.getEnvinfoDepartCharge();

    },
    computed: {
      appCodefunction:function(){
        if(this.appCode == 'platform'){
          return 'platform_departlist:import';
        }else if(this.appCode == 'env_audit'){
          return 'env_audit_departlist:import';
        }else if(this.appCode == 'ipsys'){
          return 'ipsys_departlist:import'
        }else if(this.appCode == 'sweep'){
          return 'sweep_departlist:import'
        }else if(this.appCode == 'envinfo'){
          return "envinfo_departlist:import"
        }
      },
      transferDeport_v_has(){
        if(this.appCode == 'platform'){
          return 'platform_departlist:transferDeport';
        }else if(this.appCode == 'env_audit'){
          return 'env_audit_departlist:transferDeport';
        }else if(this.appCode == 'ipsys'){
          return 'ipsys_departlist:transferDeport'
        }else if(this.appCode == 'sweep'){
          return 'sweep_departlist:transferDeport'
        }else if(this.appCode == 'envinfo'){
          return "envinfo_departlist:transferDeport"
        }
      },
      transferDeportUser_v_has(){
        if(this.appCode == 'platform'){
          return 'platform_departlist:transferDeportUser';
        }else if(this.appCode == 'env_audit'){
          return 'env_audit_departlist:transferDeportUser';
        }else if(this.appCode == 'ipsys'){
          return 'ipsys_departlist:transferDeportUser'
        }else if(this.appCode == 'sweep'){
          return 'sweep_departlist:transferDeportUser'
        }else if(this.appCode == 'envinfo'){
          return "envinfo_departlist:transferDeportUser"
        }
      },
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
      columns(){
        if (this.language){
          return [
            {
              title: this.language['depart.management.departName'],
              dataIndex: 'departName'
            },
            {
              title: this.language['depart.management.orgType'],
              align: 'center',
              dataIndex: 'orgType'
            },
            {
              title: this.language['depart.management.orgCode'],
              dataIndex: 'orgCode',
            },
            {
              title: this.language['depart.management.mobile'],
              dataIndex: 'mobile'
            },
            {
              title: this.language['depart.management.fax'],
              dataIndex: 'fax'
            },
            {
              title: this.language['depart.management.address'],
              dataIndex: 'address'
            },
            {
              title: this.language['common.sort'],
              align: 'center',
              dataIndex: 'departOrder'
            },
            {
              title: this.language['common.action'],
              align: 'center',
              dataIndex: 'action',
              scopedSlots: {customRender: 'action'}
            }
          ]
        }
      },
      userColumns() {
        if (this.language) {
          return  [{
            title: this.language['user.column.userAccount'],
            align: "center",
            dataIndex: 'username'
          },
            {
              title: this.language['user.column.realname'],
              align: "center",
              dataIndex: 'realname'
            },
            {
              title: this.language['depart'],
              align: "center",
              dataIndex: 'orgCode'
            },
            {
              title: this.language['user.column.sex'],
              align: "center",
              dataIndex: 'sex_dictText'
            },
            {
              title: this.language['user.column.phone'],
              align: "center",
              dataIndex: 'phone'
            }]
        }
      },
      userColumns2() {
        if (this.language) {
          return  [
            {
              title: '#',
              dataIndex: '',
              key: 'rowIndex',
              width: 20,
              align: "center",
              customRender: function (t, r, index) {
                return parseInt(index) + 1;
              }
            },
            {
              title: this.language['user.column.userAccount'],
              align: "center",
              width:100,
              dataIndex: 'username'
            },
            {
              title: this.language['user.column.realname'],
              align: "center",
              width:100,
              dataIndex: 'realname'
            },
            {
              title: this.language['depart'],
              align: "center",
              width:100,
              dataIndex: 'orgCode'
            },
            {
              title: this.language['depart.management.dimensionName'],
              dataIndex: 'dimensionName',
              width:120,
              align:"center",
              scopedSlots: { customRender: 'dimensionName' }
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              width:100,
              align:"center",
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      },
    },
    methods: {
      departNameLanguageOpen(){
        this.languageModelOpen('SysDepart','departName',this.model.id,this.model.departNameLanguages)
      },
      languageModelOpen(dataTable,dataColumn,dataId,languagelist){
        this.$refs.languageModel.edit("platform",dataTable,dataColumn,dataId,languagelist);
      },
      languageOk(map){
        if(map&&map.dataColumn == 'departName'){
          this.model.departNameLanguages = map.languagelist;
        }
      },
      userData2edit (id) {
        const newData = [...this.userDataSource2];
        const target = newData.filter(item => id === item.id)[0];
        // 根据rowKey判断该行数据是否存在
        if (target) {
          target.editable = true;   // 修改target可以直接影响到newData
          this.userDataSource2 = newData
        }
      },
      userData2save (row) {
        const newData = [...this.userDataSource2];
        const target = newData.filter(item => row.id === item.id)[0];
        if (target) {
          postAction("/sys/sysdatapermission/save?applicationId="+this.$store.getters.application.id,row).then((res)=>{
            if(res.success){
              delete target.editable;
              this.userDataSource2 = newData
            }
          })
        }
      },
      userData2cancel (row) {
        console.log(row);
        const newData = [...this.userDataSource2];
        const target = newData.filter(item => row.id === item.id)[0];
        if (target) {
          // 将缓存数据中匹配到的数据对象覆盖合并当前被修改的行
          // target.editable = false;
          delete target.editable;
          this.userDataSource2 = newData
        }
      },
      submitData(){
        if(this.submitDimensionCode.length>0&&this.selectionRows.length>0){
          let that = this;
          let rows = that.selectionRows;
          let dimensionCodelist = that.submitDimensionCode;
          that.$confirm({
            title: that.language['confirm.titleConfirmOperation'],
            content: that.language["depart.management.trueBetchSetDimension"],
            onOk: function () {
              rows.forEach(item=>{
                item.dimensionCode = dimensionCodelist;
              })
              postAction("/sys/sysdatapermission/saveBatch?applicationId="+that.$store.getters.application.id,rows).then((res)=>{
                if(res.success){
                  // that.selectUserData2(that.selectedKeys[0]);
                }
              })
            }
          })

        }
      },


      uploadDepartXls(){
        this.$refs.DepartUploadOrDownloadModal.edit()
      },
      /*ExportTemplateXls(){
        let url = window._CONFIG['domianURL'] + "/sys/sysDepart/exportTemplateXls"
        window.open(url);
      },*/
      initDataPermissionList(){
        getAction("/sys/sysdatapermissionconfig/allList",{applicationId:this.$store.getters.application.id}).then((res)=>{
          if(res.success){
            this.dataPermissionList = res.result;
          }
        })
      },
      dimensionCodeSearch(){
        this.selectUserData2(this.selectedKeys[0]);
      },
      dimensionCodeSearchReset(){
        this.dimensionCodeQueryParamWorkNo = ""
        this.dimensionCodeQueryParamRealName = ""
        this.dimensionCodeQueryParamUsername = ""
        this.selectUserData2(this.selectedKeys[0]);
      },
      userTableChange2(arg){
        this.ipagination2.current = arg.current;
        this.ipagination2.pageSize = arg.pageSize;
        this.selectUserData2(this.selectedKeys[0],arg.current,arg.pageSize);
      },
      selectUserData2(departId,pageNo,pageSize){
        this.userTabelLoading2 = true
        if(pageNo){
          this.ipagination2.current = pageNo;
        }else{
          this.ipagination2.current = 1;
        }
        if(pageSize){
          this.ipagination2.pageSize = pageSize;
        }else{
          this.ipagination2.pageSize = 10;
        }
        let params = {};
        params.applicationCode = this.$store.getters.applicationCode
        params.depId = departId;
        params.pageNo = pageNo;
        params.pageSize = pageSize;
        params.workNo = this.dimensionCodeQueryParamWorkNo
        params.realName = this.dimensionCodeQueryParamRealName
        params.username = this.dimensionCodeQueryParamUsername
        getAction("/sys/sysdatapermission/departUserList", params).then((res) => {
          if (res.success && res.result) {
            this.userDataSource2 = res.result.records;
            this.ipagination2.total = res.result.total;
            this.userTabelLoading2 = false
          }
        })
      },
      userTableChange(arg){
        this.ipagination.current = arg.current;
        this.ipagination.pageSize = arg.pageSize;
        this.selectUserData(this.selectedKeys[0],arg.current,arg.pageSize);
      },
      selectUserData(departId,pageNo,pageSize){
        this.userTabelLoading = true
        if(pageNo){
          this.ipagination.current = pageNo;
        }else{
          this.ipagination.current = 1;
        }
        if(pageSize){
          this.ipagination.pageSize = pageSize;
        }else{
          this.ipagination.pageSize = 10;
        }
        let params = {};
        params.applicationCode = this.$store.getters.applicationCode
        params.depId = departId;
        params.pageNo = pageNo;
        params.pageSize = pageSize;
        getAction("/sys/user/departUserList", params).then((res) => {
          if (res.success && res.result) {
            this.userDataSource = res.result.records;
            this.ipagination.total = res.result.total;
            this.userTabelLoading = false
          }
        })
      },
      selectStandardDepart(){
        this.$refs.standardDepartModal.loadTree()
      },
      loadData() {
        this.refresh();
      },
      loadTree() {
        var that = this
        that.treeData = []
        that.departTree = []
        queryDepartTreeList({"applicationCode":this.$store.getters.applicationCode}).then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            this.allTreeKeys = [];
            if(res.result.length==0){
              this.importPlatformbtn = false;
            }else{
              for (let i = 0; i < res.result.length; i++) {
                let temp = res.result[i]
                that.treeData.push(temp)
                that.departTree.push(temp)
                /*展开所有节点*/
                // that.setThisExpandedKeys(temp)
                that.getAllKeys(temp);
                // console.log(temp.id)
              }
            }
            /*if(that.departTree==[]){
              that.standardDepartShow=true;
            }else{
              that.standardDepartShow=false;
            }*/
            this.loading = false
          }
        })
      },
      getLegalPersons(){
        getAction("/sys/sysDepart/getLegalPersonList").then((res) => {//{id: this.model.artificialPerson}
          if (res.success) {
            this.artificialPersonList = res.result;
          }
        })
      },
      getDepartSites(){
        getAction("/sys/sysDepart/getFactoryList").then((res) => {//, {id: this.model.siteCode}
          if (res.success) {
            this.siteCodeList = res.result;
          }
        })
      },
      setThisExpandedKeys(node) {
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.key)
          for (let a = 0; a < node.children.length; a++) {
            this.setThisExpandedKeys(node.children[a])
          }
        }
      },
      refresh() {
        this.loading = true
        this.loadTree()
      },
      // 右键操作方法
      rightHandle(node) {
        //this.dropTrigger = 'contextmenu'
        //console.log(node.node.eventKey)
        //this.rightClickSelectedKey = node.node.eventKey
        //this.rightClickSelectedOrgCode = node.node.dataRef.orgCode
      },
      onExpand(expandedKeys) {
        console.log('onExpand', expandedKeys)
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },
      backFlowList() {
        this.$router.back(-1)
      },
      // 右键点击下拉框改变事件
      dropStatus(visible) {
        if (visible == false) {
          this.dropTrigger = ''
        }
      },
      // 右键下拉关闭下拉框
      closeDrop() {
        this.dropTrigger = ''
      },
      addRootNode() {
        this.$refs.nodeModal.add(this.currFlowId, '')
      },
      batchDel: function () {
        console.log(this.checkedKeys)
        if (this.checkedKeys.length <= 0) {
          this.$message.warning(this.language['tip.messageSelectRecord'])
        } else {
          var ids = ''
          for (var a = 0; a < this.checkedKeys.length; a++) {
            ids += this.checkedKeys[a] + ','
          }
          var that = this
          this.$confirm({
            title: this.language['confirm.deletion'],
            content: this.language['sure.delete.selected'] + this.checkedKeys.length + this.language['piece.data.node'],
            onOk: function () {
              deleteAction(that.url.deleteBatch, {ids: ids}).then((res) => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.loadTree()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.message)
                }
              })
            }
          })
        }
      },
      onSearch(value) {
        let that = this
        if (value) {
          searchByKeywords({keyWord: value,applicationCode:this.$store.getters.applicationCode}).then((res) => {
            if (res.success) {
              that.departTree = []
              for (let i = 0; i < res.result.length; i++) {
                let temp = res.result[i]
                that.departTree.push(temp)
              }
            } else {
              that.$message.warning(res.message)
            }
          })
        } else {
          that.loadTree()
        }

      },
      nodeModalOk() {
        this.loadTree()
      },
      nodeModalClose() {
      },
      hide() {
        console.log(111)
        this.visible = false
      },
      onCheck(checkedKeys, info) {
        console.log('onCheck', checkedKeys, info)
        this.hiding = false
        //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------
        if(this.checkStrictly){
          this.checkedKeys = checkedKeys.checked;
        }else{
          this.checkedKeys = checkedKeys
        }
        //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------
      },
      initLanguagetemp(dataTable,dataColumn,dataId){
        getAction("/sys/syslanguagedata/querylistby", {applicationCode:"platform",dataTable:dataTable,dataColumn:dataColumn,dataId:dataId}).then((res)=> {
          if (res.success) {
            // this.checkedDataId = dataId
            this.model.departNameLanguages = res.result;
          }
        })
      },
      onSelect(selectedKeys, e) {
        // debugger
        console.log('selected', selectedKeys, e)
        this.hiding = false
        let record = e.node.dataRef
        // this.departMangerURL = '/sys/user/getDepartUserForConditions?departId='+record.id
        // this.departMangerURL = '/sys/user/getDepartUser?applicationCode='+this.$store.getters.applicationCode
        console.log('onSelect-record', record)
        this.currSelected = Object.assign({}, record)
        this.model = this.currSelected
        console.log("this.model：",this.model)
        this.selectedKeys = [record.key]
        this.model.parentId = record.parentId
        this.setValuesToForm(record)
        this.$refs.departAuth.show(record.id);
        this.selectUserData(record.id);
        this.selectUserData2(record.id);
        this.$refs.checker.show(record.id);
        this.submitDimensionCode=[]
        this.selectionRows=[]
        this.selectedRowKeys = [];
        this.initLanguagetemp('SysDepart','departName',record.key);
        /*this.$refs.DeptUserInfo.onClearSelected();
        this.$refs.DeptUserInfo.open(record);*/
        this.getEnvinfoDepartCharge();
        if(this.envchargeModel.records.length>0) {
          var tmpModel=this.model;
          var envinfoDept = this.envchargeModel.records.filter(item => {
           return tmpModel.id === item.departId
          });
          if (envinfoDept != null&&envinfoDept.length>0) {
            this.$set(this.model, "departChief", envinfoDept[0].workNo);
          }
        }
      },
      getlevelDictCode(){
        getAction("/sys/sysDepart/getApplicationLevel", {applicationCode:this.$store.getters.applicationCode}).then((res)=> {
          if (res.success) {
            this.levelDictCode = res.result;
          }else{
            this.levelDictCode = "depart_category";
          }
        })
      },
      getEnvinfoDepartCharge(){
        getAction("/epi/departCharge/list", {applicationCode:this.$store.getters.applicationCode}).then((res)=> {
          if (res.success) {
            this.envchargeModel = res.result;
          }else{
            this.envchargeModel = [];
          }
        })
      },
      // 触发onSelect事件时,为部门树右侧的form表单赋值
      setValuesToForm(record) {
        if(record.orgCategory == '1'){
          this.orgCategoryDisabled = true;
        }else{
          this.orgCategoryDisabled = false;
        }
      },
      getCurrSelectedTitle() {
        return !this.currSelected.title ? '' : this.currSelected.title
      },
      onClearSelected() {
        this.hiding = true
        this.checkedKeys = []
        this.currSelected = {}
        this.selectedKeys = []
        if(this.$refs.departAuth){
          this.$refs.departAuth.departId = ''
        }
      },
      handleNodeTypeChange(val) {
        this.currSelected.nodeType = val
      },
      notifyTriggerTypeChange(value) {
        this.currSelected.notifyTriggerType = value
      },
      receiptTriggerTypeChange(value) {
        this.currSelected.receiptTriggerType = value
      },
      submitCurrForm() {
        this.currSelected.departChief = this.model.departChief;
        debugger;
        this.$refs.form.validate(valid => {
          if (valid) {
            if (!this.currSelected.id) {
              this.$message.warning(this.language["common.pleaseChoose"]+this.language['deport'])
              return
            }
           //httpAction(this.url.edit, this.currSelected, 'put').then((res) => {
            httpAction("/epi/departCharge/add",this.currSelected,"post").then((res)=>{
              if (res.success) {
                httpAction("/sys/syslanguagedata/saveSysLanguageDataList",this.model.departNameLanguages,"post").then((res)=>{
                  if(res.success){
                    this.$message.success(this.language['system.savedSuccess'])
                    this.loadTree()
                  }
                })
              } else {
                this.$message.error(res.message)
              }
            })
          }
        })
      },
      emptyCurrForm() {
        this.$refs.form.resetFields();
        this.model={}
      },
      nodeSettingFormSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            console.log('Received values of form: ', this.model)
          }
        })
      },
      openSelect() {
        this.$refs.sysDirectiveModal.show()
      },
      handleAdd(num) {
        if (num == 1) {
          this.$refs.departModal.add()
          this.$refs.departModal.title = this.language['common.insertButton']
        } else if (num == 2) {
          let key = this.currSelected.key
          if (!key) {
            this.$message.warning(this.language['common.pleaseChoose']+this.language['depart.management.FDepart'])
            return false
          }
          this.$refs.departModal.add(this.selectedKeys)
          this.$refs.departModal.title = this.language['common.insertButton']
        } else {
          this.$refs.departModal.add(this.rightClickSelectedKey)
          this.$refs.departModal.title = this.language['common.insertButton']
        }
      },
      handleDelete() {
        var that = this
        this.$confirm({
          title: this.language['confirm.deletion'],
          content: this.language['sure.delete.Deport']+this.language['system.andDataNode'],
          onOk: function () {
            getAction("/sys/user/departUserList", {applicationCode:that.$store.getters.applicationCode,depId:that.rightClickSelectedKey,pageNo:1,pageSize:1}).then((res) => {
              if (res.success && res.result) {
                if(res.result.total>0){
                  that.$message.warning(that.language['depart.management.removeFailedWarn'])
                }else{
                  deleteByDepartId({id: that.rightClickSelectedKey}).then((resp) => {
                    if (resp.success) {
                      //删除成功后，去除已选中中的数据
                      that.checkedKeys.splice(that.checkedKeys.findIndex(key => key === that.rightClickSelectedKey), 1);
                      that.$message.success(that.language['common.deleteSuccess'])
                      that.loadTree()
                      //删除后同步清空右侧基本信息内容
                      let orgCode=that.model.orgCode;
                      if(orgCode && orgCode === that.rightClickSelectedOrgCode){
                        that.onClearSelected()
                      }
                    } else {
                      that.$message.warning(this.language['common.deleteError'])
                    }
                  })
                }
              }
            })


          }
        })
      },
      getAllNodes(node) {
        this.allTreeNodes.push(node);
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllNodes(node.children[a])
          }
        }
      },
      handleTransferOrg(nodeList,selectedNode){
        if(selectedNode == undefined || selectedNode == null || selectedNode.length == 0){
          this.$warning({ title: this.language['operationfailed'], content: this.language['common.pleaseChoose']+this.language['depart'] })
          return false;
        }
        httpAction('/sys/sysDepart/checkTransferOrNot?id='+selectedNode[0], '', "get").then((res) => {
          if (res.success) {
            if(res.result == 'Y'){
              nodeList.map(item=>{
                this.getAllNodes(item);
              });
              let selectedNodeData;
              this.allTreeNodes.map(item=>{
                if(item.id == selectedNode[0]){
                  selectedNodeData = item;
                }
              });
              this.$refs.departTransferModal.edit(selectedNodeData);
              this.$refs.departTransferModal.title = this.language['depart.management.transferDeport']
            } else {
              this.$warning({ title: this.language['operationfailed'], content: this.language['depart.management.departMoving'] })
              return false;
            }
          }
        })
      },
      handleTransferPerson(nodeList,selectedNode){
        if(selectedNode == undefined || selectedNode == null || selectedNode.length == 0){
          this.$warning({ title: this.language['operationfailed'], content: this.language['common.pleaseChoose']+this.language['depart']  })
          return false;
        }
        nodeList.map(item=>{
          this.getAllNodes(item);
        });
        let selectedNodeData;
        this.allTreeNodes.map(item=>{
          if(item.id == selectedNode[0]){
            selectedNodeData = item;
          }
        });
        this.$refs.departTransferEmployeeModal.edit(selectedNodeData);
        this.$refs.departTransferEmployeeModal.title = this.language['depart.management.transferDeportUser']
      },
      selectDirectiveOk(record) {
        console.log('选中指令数据', record)
        this.nodeSettingForm.setFieldsValue({directiveCode: record.directiveCode})
        this.currSelected.sysCode = record.sysCode
      },
      getFlowGraphData(node) {
        this.graphDatasource.nodes.push({
          id: node.id,
          text: node.flowNodeName
        })
        if (node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            let temp = node.children[a]
            this.graphDatasource.edges.push({
              source: node.id,
              target: temp.id
            })
            this.getFlowGraphData(temp)
          }
        }
      },
     //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------
      expandAll () {
        this.iExpandedKeys = this.allTreeKeys
      },
      closeAll () {
        this.iExpandedKeys = []
      },
      checkALL () {
        this.checkStriccheckStrictlytly = false
        this.checkedKeys = this.allTreeKeys
      },
      cancelCheckALL () {
        //this.checkedKeys = this.defaultCheckedKeys
        this.checkedKeys = []
      },
      switchCheckStrictly (v) {
        if(v==1){
          this.checkStrictly = false
        }else if(v==2){
          this.checkStrictly = true
        }
      },
      getAllKeys(node) {
        // console.log('node',node);
        this.allTreeKeys.push(node.key)
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllKeys(node.children[a])
          }
        }
      }
      //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------

    },

  }
</script>
<style scoped>
  .ant-card-body .table-operator {
    margin: 15px;
  }

  .anty-form-btn {
    width: 100%;
    text-align: center;
  }

  .anty-form-btn button {
    margin: 0 5px;
  }

  .anty-node-layout .ant-layout-header {
    padding-right: 0
  }

  .header {
    padding: 0 8px;
  }

  .header button {
    margin: 0 3px
  }

  .ant-modal-cust-warp {
    height: 100%
  }

  .ant-modal-cust-warp .ant-modal-body {
    height: calc(100% - 110px) !important;
    overflow-y: auto
  }

  .ant-modal-cust-warp .ant-modal-content {
    height: 90% !important;
    overflow-y: hidden
  }

  #app .desktop {
    height: auto !important;
  }

  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }

  .drawer-bootom-button {
    /*position: absolute;*/
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: left;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>